<template>
  <q-td :auto-width="autoWidth" :props="props" :key="rowKey">
    <slot />
  </q-td>
</template>

<script>
export default {
  name: 'Td',
  props: {
    autoWidth: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      type: String,
    },
    props: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped></style>
